import React, { useState, Component, useEffect, useRef, useContext } from 'react';
import '../Header/Header.scss';
import '../../../styles/styles.css'
import { useFlags } from 'launchdarkly-react-client-sdk';
import { EAccountStatus } from '../../../common/enum/EAccountStatus';
import { EDashboardReturnLinkEnum } from '../../../common/enum/EDashboardReturnLinkEnum';
import { authContext } from '../../../provider/Context/AuthContext';
import { userContext } from "../../../provider/Context/UserContext";

export interface IHeaderProps {
    LoggedIn: boolean,
    canAddCssShow: boolean,
    AccountStatus?: EAccountStatus,
    NameInitials?: string,
    AdminSourceId?: number
}

const Header: React.FC<IHeaderProps> = (props) => {
    let loginNavItem;
    let signUpButton;
    let logOutButton;
    let communityLink;
    let dashboardLink = <a id="btn-header-logout" href="/Dashboard" className="link navigation1-link">Return to Dashboard</a>;
    let returnLink;
    let [canAddCssClass, setShowCssClass] = useState(props.canAddCssShow);
    const [showDashboardLink, setdashboardLink] = useState(false);
    const [accountstatus, setaccountStatus] = useState(props.AccountStatus);
    const auth = useContext(authContext);
    const userDetails = useContext(userContext);
    const [showAccountLink, setAccountLink] = useState(false);
    const [showDropDownHeader, setDropDownHeader] = useState(false);
    const [showReturnLink, setReturnLink] = useState(false);
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const { showApiMaticDocument, showClassesWorkflowApiDocumentation } = useFlags();

    const setShowCss = () => {
        //Only add CSS this CSS class when mobile view//     
        if (window.innerWidth < 770) {
            setShowCssClass(!canAddCssClass);
        }
    }

    const SIGNUP_URL = process.env.REACT_APP_SIGNUP_URL;
    const PARTNER_BASE_URL = process.env.REACT_APP_PARTNER_BASE_URL;
    const COMMUNITY_URL = process.env.REACT_APP_COMMUNITY_URL;
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    if (props.LoggedIn == false) {
        loginNavItem = <a id="btn-header-login" href="/Home/LogIn" className="link navigation1-link login-btn-mob btn-sm-header">Login</a>
        signUpButton = <a id="btn-header-sign-up" href={SIGNUP_URL} className="btn btn-outline w-button btn-sm-header signup-btn-sm"><span className="sign-up-span">Sign Up</span></a>
        communityLink = `${COMMUNITY_URL}/index.html`;
    }
    else {
        logOutButton = <a id="btn-header-logout" href="/Home/SignOut" className="link navigation1-link btn-sm-header login-btn-mob">Sign Out</a>
        communityLink = `${COMMUNITY_URL}/users/login.html`;
    }

    const showDashboard = () => {
        if (props.LoggedIn && accountstatus && Object.values(EDashboardReturnLinkEnum).includes(EAccountStatus[String(accountstatus)])) {
            setdashboardLink(true);
            dashboardLink = <a id="btn-header-dashboard" href="/Dashboard" className="link navigation1-link">Return to Dashboard</a>;
        }
    };

    const ShowReturnLinkForAdmin = () => {
        if (props.LoggedIn && props.AdminSourceId != 0) {
            returnLink = <a id="link-header-return-admin" href="/Home/SignOut" className="sub-menu-link">Return</a>
            setReturnLink(true);
        }
    }

    useEffect(() => {
        if (canAddCssClass) {
            setShowCss();
        }
        setaccountStatus(props.AccountStatus);
        showDashboard();
        ShowReturnLinkForAdmin()
    }, [props.canAddCssShow]);

    useEffect(() => {
        if (window.innerWidth < 770) {
            setShowMobileMenu(canAddCssClass);
        }
    }, [canAddCssClass])

    useEffect(() => {
        var accountStatus = auth?.status ?? EAccountStatus.NotMentioned;

        if (props.LoggedIn) {
            setDropDownHeader(true);
        }
        if (accountStatus != EAccountStatus.NotMentioned && accountStatus != EAccountStatus.Approved) {
            setAccountLink(true);
        }
    }, [auth]);

    return (
        <div className="section header-main">
            <div className="wrap _w-custom nav1">
                <div data-collapse="medium" data-animation="default" data-duration="400" role="banner" className="nav1 w-nav">
                    <div className="nav1-wrap">
                        <div className="nav1-menu-wrapper">
                            <a id="btn-header-logo" className="logo-link" href="/">
                                <img className="nav1-logo mb-log-img" alt="Mindbody Developer" loading="lazy" width="150"></img>
                            </a>
                            {showApiMaticDocument &&
                                <div id="api-drop-down" className="dropdown-menu-new">
                                    <span className="dropdown-new">Documentation <i className="drop-down-icon"></i></span>
                                    <div className="dropdown-content-new">
                                        <ul className="dropdown-ul">
                                            {userDetails?.user?.CanShowV5 &&

                                                <li className="sub-menu-link"><a href="/PublicDocumentation/GettingStarted?version=V5.0">Public API V5.x</a></li>
                                            }
                                            <li className="sub-menu-link"><a className="active" href="/ui/documentation/public-api">Public API V6.0</a></li>
                                            <li className="sub-menu-link"><a href="/ui/documentation/webhooks-api">Webhooks API</a></li>
                                            <li className="sub-menu-link"><a href="/ui/documentation/booker-api">Booker API</a></li>
                                            {showClassesWorkflowApiDocumentation &&
                                                <li className="sub-menu-link"><a href="/ui/documentation/classes-workflow-api">Classes Workflow API</a></li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                            {!showApiMaticDocument &&
                                <a id="btn-header-api" href="/PublicDocumentation/V6" className="link navigation1-link w-nav-menu">APIs</a>
                            }
                            <a id="btn-header-ps" href={`${PARTNER_BASE_URL}en-US/home`} target="_blank" className="link navigation1-link w-nav-menu">Partner Store</a>

                        </div>
                        <div className="nav1-menu-wrapper w-nav-menu">
                            <div className="d-flex align-items-center"> {loginNavItem}</div>
                            {showDashboardLink &&
                                <div className="logout-link">{dashboardLink}</div>
                            }
                            {!showDropDownHeader && !showReturnLink &&
                                <div className="logout-link"> {logOutButton}</div>
                            }
                            {!showDropDownHeader && showReturnLink &&
                                returnLink
                            }
                            {signUpButton}
                            {showDropDownHeader && props.LoggedIn &&
                                <div className="dropdown-menu-new-1">
                                    <span>
                                        <span className="i-circle">{props.NameInitials}<i className="drop-down-icon drop-down-icon-circle"></i></span>
                                    </span>
                                    <div className="dropdown-content-circle">
                                        <ul className="dropdown-ul">
                                            <li className="sub-menu-link"><a id="btn-header-dashboard" href="/Dashboard">Dashboard</a></li>
                                            {showAccountLink &&
                                                <li className="sub-menu-link"><a id="btn-header-account-profile" href={`${BASE_URL}Account/Profile`}>Account</a></li>
                                            }
                                            <li className="sub-menu-link"><a id="btn-header-support" href="https://support.mindbodyonline.com/s/contactapisupport" target="_blank">Support</a></li>
                                            {!showReturnLink &&
                                                <li className="sub-menu-link"><a id="btn-header-logout" href="/Home/SignOut">Sign Out</a></li>
                                            }
                                            {showReturnLink &&
                                                <li className="sub-menu-link"><a id="link-header-return-admin" href="/Home/SignOut" className="sub-menu-link">Return</a></li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={`nav1-menu-btn w-nav-button w--open ${canAddCssClass == true ? '' : 'collapsed'}`} data-toggle="collapse" data-target="#w-nav-overlay-0" aria-controls="navbar" aria-label="menu" role="button" tabIndex={1} aria-haspopup="menu" >
                            <img width="30" className="nav1-menu-icon menu-icon-img" alt="Menu" id="mb-header-btn" onClick={setShowCss}></img>
                        </div>
                    </div>
                    <div className={`m-nav-transition ${canAddCssClass == true ? '' : 'show'}`} data-wf-ignore id="w-nav-overlay-0" aria-hidden="true" onClick={setShowCss}>
                        <nav role="navigation" id="nav1" className={`m-nav-content ${showMobileMenu == true ? 'show' : ''}`}>

                            <div className="m-nav-link-container">
                                <div>
                                    <img width="30" className="nav1-menu-icon menu-icon-close-img" alt="Menu" id="mb-header-btn" onClick={setShowCss}></img>
                                </div>
                                <div className="link-mb-div">
                                    <a id="btn-header-api-mb" href="/PublicDocumentation/V6" className="link navigation1-link mb-link">APIs</a>
                                    <a id="btn-header-ps-mb" href={`${PARTNER_BASE_URL}en-US/home`} target="_blank" className="link navigation1-link mb-link" >Partner Store</a>
                                    
                                    {showAccountLink && props.LoggedIn &&
                                        <a id="btn-header-account-profile" href={`${BASE_URL}Account/Profile`} className="link navigation1-link mb-link" >Account</a>
                                    }
                                    <a id="btn-header-support" href="https://support.mindbodyonline.com/s/contactapisupport" target="_blank" className="link navigation1-link mb-link" >Support</a>
                                </div>
                                <div className="button-div-sm">
                                    {loginNavItem}
                                    {signUpButton}
                                    {showDashboardLink &&
                                        <div className="logout-link"> {dashboardLink}</div>
                                    }
                                    {logOutButton}
                                    {returnLink}
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;

